export const SYNC_FAILED = 'devices_sync_has_failed';
export const SYNC_FINISHED = 'devices_sync_has_finished';
export const SYNC_INITIATED = 'devices_sync_was_initiated';
export const SET_DEVICES = 'set_devices';
